import { API_URL } from "../constants";

class PDFService {
    async download(username, data) {
        try {
            const filename = `Account-Statement-${username}-${data.to_date}`;
            const response = await fetch(`${API_URL}/ledger/generate-pdf`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                    // 'x-authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                throw new Error("Failed to download images");
            }

            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `${filename}.pdf`;
            link.click();

            return { success: true, message: 'File has been downloaded' }

        } catch (error) {
            console.error("Error downloading images:", error);
            return { success: false, message: "Error downloading images:" + error }
        }
    }
}

const PdfService = new PDFService();
export default PdfService;
